<app-navbar-style-three></app-navbar-style-three>
<section class="bg-image">
    <div class="container">
        <div class="pt-3 pb-3" *ngIf="!fetchinData">
            <div class="row">
                <div class="col-md-3">
                    <div align="left" style="padding-left: 20px">
                        <p style="font-size: 26px">About Us</p>
                    </div>
                    <div class="list-group list-group-flush">
                        <ng-container *ngFor="let item of items">
                            <button
                                [class.active]="selectedItem === item.Url"
                                (click)="selectItem(item.Url)"
                                class="newA linkStyle list-group-item list-group-item-action"
                            >
                                {{ item.Name }}
                            </button>
                        </ng-container>
                    </div>
                </div>
                <div class="col-md-9">
                    <div style="min-height: 800px">
                        <div>
                            <h3>{{ selectedItemName }}</h3>
                            <hr />

                            <!-- New -->
<!-- Why Study -->
<div
    class="container"
    *ngIf="selectedItem && selectedItem == 'why-study'"
>
    <ng-container *ngIf="why_std == null" class="spinner-overlay">
        <span class="fetching-data-text">No Data Found</span>
    </ng-container>
    <ng-container *ngIf="why_std != null">
        <div class="container card" style="padding: 20px">
            <div class="row justify-content-center">
                <article class="col-md-12 text-justify p-4">
                    <div *ngIf="why_std?.ShowAttachments?.length > 0">
                        <div id="whyStudyCarousel" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-indicators">
                                <button 
                                    *ngFor="let img of why_std.ShowAttachments; let i = index"
                                    type="button"
                                    data-bs-target="#whyStudyCarousel"
                                    [attr.data-bs-slide-to]="i"
                                    [class.active]="i === 0"
                                    aria-current="true"
                                    [attr.aria-label]="'Slide ' + (i + 1)">
                                </button>
                            </div>
                            <div class="carousel-inner">
                                <div 
                                    *ngFor="let img of why_std.ShowAttachments; let i = index" 
                                    class="carousel-item"
                                    [class.active]="i === 0">
                                    <img 
                                        [src]="img.FilePath"
                                        class="d-block w-100"
                                        style="height: 300px; object-fit: cover; border-radius: 10px;"
                                        alt="Why Study Image" />
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#whyStudyCarousel" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#whyStudyCarousel" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                    <p style="text-align: justify" [innerHTML]="why_std.DetailsEn"></p>
                </article>
            </div>
        </div>
    </ng-container>
</div>

                            <div
                                class="container"
                                *ngIf="
                                    selectedItem && selectedItem == 'history'
                                "
                            >
                                <ng-container
                                    *ngIf="histry == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container *ngIf="histry != null">
                                    <div
                                        class="container card"
                                        style="padding: 20px"
                                    >
                                        <div class="row justify-content-center">
                                            <article
                                                class="col-md-12 text-justify p-4"
                                            >
                                                <div>
                                                    <img
                                                        class="img-fluid"
                                                        style="
                                                            height: auto;
                                                            width: 100%;
                                                            object-fit: cover;
                                                            border-radius: 10px;
                                                        "
                                                        [src]="
                                                            histry
                                                                .ShowAttachments[0]
                                                                .FilePath
                                                        "
                                                    />
                                                </div>

                                                <p
                                                    style="text-align: justify"
                                                    [innerHTML]="
                                                        histry.DetailsEn
                                                    "
                                                ></p>
                                            </article>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>

                            
<!-- Mission and Vision -->
<div
    class="container"
    *ngIf="selectedItem && selectedItem == 'mission-and-vision'"
>
    <ng-container
        *ngIf="mission_data == null"
        class="spinner-overlay"
    >
        <span class="fetching-data-text">No Data Found</span>
    </ng-container>

    <ng-container *ngIf="mission_data != null">
        <div class="container card" style="padding: 20px">
            <div class="row justify-content-center">
                <article class="col-md-12 text-justify p-4">
                    <div *ngIf="mission_data?.ShowAttachments?.length > 0">
                        <div id="missionCarousel" class="carousel slide" data-bs-ride="carousel">

                            <!-- Indicators -->
                            <div class="carousel-indicators">
                                <button 
                                    *ngFor="let img of mission_data.ShowAttachments; let i = index"
                                    type="button" 
                                    data-bs-target="#missionCarousel"
                                    [attr.data-bs-slide-to]="i"
                                    [class.active]="i === 0"
                                    aria-current="true"
                                    [attr.aria-label]="'Slide ' + (i + 1)">
                                </button>
                            </div>

                            <!-- Slides -->
                            <div class="carousel-inner">
                                <div 
                                    *ngFor="let img of mission_data.ShowAttachments; let i = index" 
                                    class="carousel-item" 
                                    [class.active]="i === 0">

                                    <img 
                                        [src]="img.FilePath" 
                                        class="d-block w-100 club-image" 
                                        style="height: 300px; object-fit: cover; border-radius: 10px;"
                                        alt="Mission Image" />
                                </div>
                            </div>

                            <!-- Controls -->
                            <button class="carousel-control-prev" type="button" data-bs-target="#missionCarousel" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#missionCarousel" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>

                    <p style="text-align: justify" [innerHTML]="mission_data.DetailsEn"></p>
                </article>
            </div>
        </div>
    </ng-container>
</div>

                            <div
                                class="container"
                                *ngIf="
                                    selectedItem &&
                                    selectedItem == 'saint-gregory'
                                "
                            >
                                <ng-container
                                    *ngIf="Sant_gregory == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container *ngIf="Sant_gregory != null">
                                    <div
                                        class="container card"
                                        style="padding: 20px"
                                    > 
                                    <div class="row justify-content-center">
                                        <article
                                            class="col-md-12 text-justify p-4"
                                        >
                                            <div>
                                                <img
                                                    class="img-fluid"
                                                    style="
                                                        height: auto;
                                                        width: 100%;
                                                        object-fit: cover;
                                                        border-radius: 10px;
                                                    "
                                                    [src]="
                                                        Sant_gregory
                                                            .ShowAttachments[0]
                                                            .FilePath
                                                    "
                                                />
                                            </div>

                                            <p
                                                style="text-align: justify"
                                                [innerHTML]="
                                                    Sant_gregory.DetailsEn
                                                "
                                            ></p>
                                        </article>
                                    </div>
                                    </div>
                                </ng-container>
                            </div>

                            <!-- Legend Data -->
                            <div
                                class="container"
                                *ngIf="
                                    selectedItem &&
                                    selectedItem == 'the-legend-gregorian'
                                "
                            >
                                <ng-container
                                    *ngIf="legends_data == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>

                                <div
                                    class="row justify-content-center"
                                    *ngIf="legends_data != null"
                                >
                                    <ng-container
                                        *ngFor="let item of legends_data"
                                    >
                                        <section
                                            class="team-area card"
                                            style="padding: 10px"
                                        >
                                            <div class="container">
                                                <div
                                                    class="row justify-content-center"
                                                >
                                                    <div
                                                        class="col-lg-4 col-md-6 col-sm-6"
                                                    >
                                                        <div
                                                            class="single-team-box"
                                                        >
                                                            <div class="image">
                                                                <img
                                                                    [src]="
                                                                        item.ImagePath
                                                                    "
                                                                    alt="team"
                                                                />
                                                                <div
                                                                    class="social"
                                                                >
                                                                    <a
                                                                        href="#"
                                                                        target="_blank"
                                                                        ><i
                                                                            class="fab fa-facebook-f"
                                                                        ></i
                                                                    ></a>
                                                                    <a
                                                                        href="#"
                                                                        target="_blank"
                                                                        ><i
                                                                            class="fab fa-twitter"
                                                                        ></i
                                                                    ></a>
                                                                    <a
                                                                        href="#"
                                                                        target="_blank"
                                                                        ><i
                                                                            class="fab fa-instagram"
                                                                        ></i
                                                                    ></a>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="content"
                                                            >
                                                                <h3>
                                                                    {{
                                                                        item.Name
                                                                    }}
                                                                </h3>
                                                                <span>
                                                                    {{
                                                                        item.GBDesignation
                                                                    }}</span
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </ng-container>
                                </div>
                            </div>
                            <!-- Legend Data Ends -->

<ng-container
                            *ngIf="
                                selectedItem &&
                                selectedItem === 'news-and-events'
                            "
                        >
                            <div
                                class="container card"
                                style="
                                    background-image: url('/assets/img/school/bg-popup.png');
                                    background-size: 100px;
                                    padding: 20px;
                                    border: 1px solid #eeeeee;
                                "
                                *ngFor="let item of News_event_data"
                            >
                                <div class="container">
                                    <div class="row align-items-center">
                                        <div class="col-lg-5 col-md-12">
                                            <div class="about-image">
                                                <img
                                                    [src]="
                                                        item.ShowAttachments[0]
                                                            .FilePath
                                                    "
                                                    alt="image"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-lg-7 col-md-12">
                                            <div>
                                                <div>
                                                    <p>{{ item.TitleEn }}</p>
                                                    <p
                                                        class="card-text"
                                                        [innerHTML]="
                                                            truncateText(
                                                                item.DetailsEn,
                                                                200
                                                            )
                                                        "
                                                    ></p>
                                                    <div class="read-more">
                                                        <a
                                                            [routerLink]="[
                                                                '/news-and-events',
                                                                item.Id
                                                            ]"
                                                            >Read more</a
                                                        >
                                                    </div>

                                                    <!-- <a [routerLink]="['/news-and-events', item.Id]">Read more</a> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </ng-container>
                           <!-- Overview -->
<div
    class="container"
    *ngIf="selectedItem && selectedItem == 'overview'"
>
    <ng-container *ngIf="overview_data == null" class="spinner-overlay">
        <span class="fetching-data-text">No Data Found</span>
    </ng-container>

    <ng-container *ngIf="overview_data != null">
        <div class="container card" style="padding: 20px">
            <div class="row justify-content-center">
                <article class="col-md-12 text-justify p-4">
                    <div *ngIf="overview_data?.ShowAttachments?.length > 0">
                        <div id="overviewCarousel" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-indicators">
                                <button 
                                    *ngFor="let img of overview_data.ShowAttachments; let i = index"
                                    type="button" 
                                    data-bs-target="#overviewCarousel"
                                    [attr.data-bs-slide-to]="i"
                                    [class.active]="i === 0"
                                    aria-current="true"
                                    [attr.aria-label]="'Slide ' + (i + 1)">
                                </button>
                            </div>
                            <div class="carousel-inner">
                                <div 
                                    *ngFor="let img of overview_data.ShowAttachments; let i = index" 
                                    class="carousel-item" 
                                    [class.active]="i === 0">
                                    <img 
                                        [src]="img.FilePath" 
                                        class="d-block w-100" 
                                        style="height: auto; object-fit: cover; border-radius: 10px;"
                                        alt="Overview Image" />
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#overviewCarousel" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#overviewCarousel" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                    <p style="text-align: justify" [innerHTML]="overview_data.DetailsEn"></p>
                </article>
            </div>
        </div>
    </ng-container>
</div>

<!-- Holly Cross Brothers -->
<div
    class="container"
    *ngIf="selectedItem && selectedItem == 'holly-cross-brothers'"
>
    <ng-container *ngIf="holly_cross_data == null" class="spinner-overlay">
        <span class="fetching-data-text">No Data Found</span>
    </ng-container>

    <ng-container *ngIf="holly_cross_data != null">
        <div class="container card" style="padding: 20px">
            <div class="row justify-content-center">
                <article class="col-md-12 text-justify p-4">
                    <div *ngIf="holly_cross_data?.ShowAttachments?.length > 0">
                        <div id="hollyCarousel" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-indicators">
                                <button 
                                    *ngFor="let img of holly_cross_data.ShowAttachments; let i = index"
                                    type="button" 
                                    data-bs-target="#hollyCarousel"
                                    [attr.data-bs-slide-to]="i"
                                    [class.active]="i === 0"
                                    aria-current="true"
                                    [attr.aria-label]="'Slide ' + (i + 1)">
                                </button>
                            </div>
                            <div class="carousel-inner">
                                <div 
                                    *ngFor="let img of holly_cross_data.ShowAttachments; let i = index" 
                                    class="carousel-item" 
                                    [class.active]="i === 0">
                                    <img 
                                        [src]="img.FilePath" 
                                        class="d-block w-100" 
                                        style="height: auto; object-fit: cover; border-radius: 10px;"
                                        alt="Holly Cross Image" />
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#hollyCarousel" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#hollyCarousel" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                    <p style="text-align: justify" [innerHTML]="holly_cross_data.DetailsEn"></p>
                </article>
            </div>
        </div>
    </ng-container>
</div>

<!-- Institute Discipline -->
<div
    class="container"
    *ngIf="selectedItem && selectedItem == 'institute-discipline'"
>
    <ng-container *ngIf="institute_discipline_data == null" class="spinner-overlay">
        <span class="fetching-data-text">No Data Found</span>
    </ng-container>

    <ng-container *ngIf="institute_discipline_data != null">
        <div class="container card" style="padding: 20px">
            <div class="row justify-content-center">
                <article class="col-md-12 text-justify p-4">
                    <div *ngIf="institute_discipline_data?.ShowAttachments?.length > 0">
                        <div id="disciplineCarousel" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-indicators">
                                <button 
                                    *ngFor="let img of institute_discipline_data.ShowAttachments; let i = index"
                                    type="button" 
                                    data-bs-target="#disciplineCarousel"
                                    [attr.data-bs-slide-to]="i"
                                    [class.active]="i === 0"
                                    aria-current="true"
                                    [attr.aria-label]="'Slide ' + (i + 1)">
                                </button>
                            </div>
                            <div class="carousel-inner">
                                <div 
                                    *ngFor="let img of institute_discipline_data.ShowAttachments; let i = index" 
                                    class="carousel-item" 
                                    [class.active]="i === 0">
                                    <img 
                                        [src]="img.FilePath" 
                                        class="d-block w-100" 
                                        style="height: auto; object-fit: cover; border-radius: 10px;"
                                        alt="Institute Discipline Image" />
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#disciplineCarousel" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#disciplineCarousel" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                    <p style="text-align: justify" [innerHTML]="institute_discipline_data.DetailsEn"></p>
                </article>
            </div>
        </div>
    </ng-container>
</div>

<!-- Building Compounds -->
<div
    class="container"
    *ngIf="selectedItem && selectedItem == 'building-compunds'"
>
    <ng-container *ngIf="Building_Compunds_data == null" class="spinner-overlay">
        <span class="fetching-data-text">No Data Found</span>
    </ng-container>

    <ng-container *ngIf="Building_Compunds_data != null">
        <div class="container card" style="padding: 20px">
            <div class="row justify-content-center">
                <article class="col-md-12 text-justify p-4">
                    <div *ngIf="Building_Compunds_data?.ShowAttachments?.length > 0">
                        <div id="buildingCarousel" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-indicators">
                                <button 
                                    *ngFor="let img of Building_Compunds_data.ShowAttachments; let i = index"
                                    type="button" 
                                    data-bs-target="#buildingCarousel"
                                    [attr.data-bs-slide-to]="i"
                                    [class.active]="i === 0"
                                    aria-current="true"
                                    [attr.aria-label]="'Slide ' + (i + 1)">
                                </button>
                            </div>
                            <div class="carousel-inner">
                                <div 
                                    *ngFor="let img of Building_Compunds_data.ShowAttachments; let i = index" 
                                    class="carousel-item" 
                                    [class.active]="i === 0">
                                    <img 
                                        [src]="img.FilePath" 
                                        class="d-block w-100" 
                                        style="height: auto; object-fit: cover; border-radius: 10px;"
                                        alt="Building Image" />
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#buildingCarousel" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#buildingCarousel" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                    <p style="text-align: justify" [innerHTML]="Building_Compunds_data.DetailsEn"></p>
                </article>
            </div>
        </div>
    </ng-container>
</div>

<!-- Culture -->
<div
    class="container"
    *ngIf="selectedItem && selectedItem == 'culture'"
>
    <ng-container *ngIf="culture_data == null" class="spinner-overlay">
        <span class="fetching-data-text">No Data Found</span>
    </ng-container>

    <ng-container *ngIf="culture_data != null">
        <div class="container card" style="padding: 20px">
            <div class="row justify-content-center">
                <article class="col-md-12 text-justify p-4">
                    <div *ngIf="culture_data?.ShowAttachments?.length > 0">
                        <div id="cultureCarousel" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-indicators">
                                <button 
                                    *ngFor="let img of culture_data.ShowAttachments; let i = index"
                                    type="button" 
                                    data-bs-target="#cultureCarousel"
                                    [attr.data-bs-slide-to]="i"
                                    [class.active]="i === 0"
                                    aria-current="true"
                                    [attr.aria-label]="'Slide ' + (i + 1)">
                                </button>
                            </div>
                            <div class="carousel-inner">
                                <div 
                                    *ngFor="let img of culture_data.ShowAttachments; let i = index" 
                                    class="carousel-item" 
                                    [class.active]="i === 0">
                                    <img 
                                        [src]="img.FilePath" 
                                        class="d-block w-100" 
                                        style="height: auto; object-fit: cover; border-radius: 10px;"
                                        alt="Culture Image" />
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#cultureCarousel" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#cultureCarousel" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                    <p style="text-align: justify" [innerHTML]="culture_data.DetailsEn"></p>
                </article>
            </div>
        </div>
    </ng-container>
</div>

                        </div>
                    </div>
                </div>
            </div>

            <br />
        </div>
        <div aria-hidden="true" *ngIf="fetchinData" class="col-lg-12 col-md-12">
            <h5 class="placeholder-glow">
                <span class="placeholder col-12" style="height: 200px"></span>
            </h5>
        </div>
    </div>
</section>
